/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React, { useState, useEffect } from 'react';

import TextField from '@mui/material/TextField';
import { Tooltip, Dropdown, OverlayTrigger, Button } from 'react-bootstrap';

import _ from 'lodash';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import SelectBoxWithoutBoxComponent from '../../../../SharedModules/SelectBox/SelectBoxWithoutBox';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import CLTabs from './CLTabs';
import Preview from './Preview';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import {
  closeTab,
  redirectURLLink,
  convertPDFURLFromAPI,
  emailValidation,
  convertHtmlToEmailPlainText,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import { safeWindowOpen } from '../../../../SharedModules/CommonUtilities/safeWindowOpen';
import SafeHtmlContent from '../../../../SharedModules/CommonUtilities/SafeHtmlContent';
import {
  defaultSelectBy,
  InvNumSelectBy,
  printMedia,
  eitherMedia,
  printDraft,
} from './ConstantData';
import {
  saveCreateTemplate,
  getPrintPreview,
  getPrintDraftPDFPreview,
  setCreateTemplateExtraState,
  updateCreateLetterSaveApi,
  updateToMailIDCreateTemplate,
  fetchCreateLetterDetail,
  fetchCreateLetterDetailByLetterIDData,
  dispatchSendMailForLetter,
  sendMailWithCreateTemplate,
  dispatchGetToMailID,
  dispatchGetFromMailID,
  getFromMailIDCreateTemplate,
  updateFromMailIDCreateTemplate,
  handleErrorMessages,
  saveDisplayLetterAPI,
} from '../store/Actions';
import {
  setSelectManufacturerData,
  fetchAllManufacturerDetail,
  getContactDetails,
  maintainLabelerListData,
  setMaintainManufacturerTab,
} from '../../../Maintain/Manufacturer/store/ManufacturerAction';
import {
  selectedType,
  dispatchCellClick,
} from '../../../Maintain/Contract/store/actions';
import { getInvoiceDetailsByInvoiceNum as getInvoiceDetailsByInvNum } from '../../invoice/store/actions';
import { getRebatePgmDetail } from '../../../Maintain/RebateProgram/SearchRebate/store/actions';
import {
  FAIL_PROCESSING_REQUEST,
  SAVE_NDC,
  EMAIL_INVALID,
  EMAIL_REQUIRED,
  ENTER_VALID_EMAIL_OR_CANCEL,
  EMAIL_ID_NOT_AVAILABLE,
} from '../../../../SharedModules/Errors/constantMessageData';
import { checkActionAccessByRole } from '../../../../SharedModules/utilities/utilities';

function CreateLetterDetail() {
  const dispatch = useDispatch();
  const RequestData = useSelector(
    (state) => state?.sharedState?.LetterReducer?.detailScrenData?.searchData
  );
  const tabs = useSelector(
    (state) => state.sharedState.LetterReducer?.extraState?.tabs
  );
  const errorMessagesFromRedux = useSelector(
    (state) => state?.sharedState?.LetterReducer?.errorMessagesInRedux
  );
  const extraState = useSelector(
    (state) => state?.sharedState?.LetterReducer?.extraState
  );
  const getCreateLetterDetail = useSelector(
    (state) => state?.sharedState?.LetterReducer?.detailScrenData
  );
  const getCreateLetterDetailData = useSelector(
    (state) => state?.sharedState?.LetterReducer?.detailScrenData?.letterDetail
  );
  const getCreateLetterDetailHeader = useSelector(
    (state) => state?.sharedState?.LetterReducer?.detailScrenData?.headerDetail
  );
  const saveCreateLetterData = useSelector(
    (state) => state?.sharedState?.LetterReducer?.saveCreateLetterData
  );
  const fromMailId = useSelector(
    (state) => state?.sharedState?.LetterReducer?.fromMailId
  );
  const toMailId = useSelector(
    (state) => state?.sharedState?.LetterReducer?.toMailId
  );
  const fullScreenView = useSelector(
    (state) =>
      state.sharedState.LetterReducer?.extraState?.fullScreenView
        ?.templateDetail
  );

  const sendMail = useSelector(
    (state) => state.sharedState.LetterReducer?.sendMail
  );
  const invoiceDetail = useSelector(
    (state) => state.sharedState.LetterReducer?.invoiceDetail
  );
  const searchContractState = useSelector(
    (state) => state.sharedState?.ContractReducer?.searchContractState
  );
  const invoiceDetailsByInvoiceNum = useSelector(
    (state) =>
      state.sharedState.DisplayInvoiceReducer?.invoiceDetailsByInvoiceNum
  );
  const pgmView = useSelector(
    (state) => state?.sharedState?.SearchRebateReducer?.pgm_res
  );
  const pdfPreview = useSelector(
    (state) => state.sharedState.LetterReducer?.pdfPreview
  );
  const pdfDraftPreview = useSelector(
    (state) => state.sharedState.LetterReducer?.pdfDraftPreview
  );
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);

  const history = useHistory();
  // const [fullScreenView, changeFullScreenView] = useState('');
  const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
  const [loading, setLoading] = React.useState(false);
  const [modalView, setModalView] = React.useState(false);
  const [modalMsg, setModalMsg] = React.useState(null);
  const [pdfUrl, setPdfURL] = React.useState(null);
  const [draftPdfUrl, setDraftPdfURL] = React.useState(null);
  const [viewEmail, setViewEmail] = React.useState(false);
  const [redirect, setRedirect] = React.useState(false);
  const [emailInputValue, setEmailInputValue] = React.useState({
    to: '',
    from: '',
  });
  const [viewEmailInput, setViewEmailInput] = React.useState({
    to: false,
    from: false,
  });
  const [toEmailIdValid, setToEmailValid] = React.useState(false);
  const [fromEmailIdValid, setFromEmailValid] = React.useState(false);
  const [isEnablebyRole, setIsEnablebyRole] = React.useState(
    checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );

  // This run when state value changed and save in redux
  const setStateChange = (val) => {
    dispatch(
      setCreateTemplateExtraState({
        ...extraState,
        ...val,
      })
    );
  };

  // This run when error msg change and save in redux
  const setErrorStateChange = (val) => {
    dispatch(
      handleErrorMessages({
        ...errorMessagesFromRedux,
        ...val,
      })
    );
  };

  const callFewAPIWhenNotSameTemplate = React.useCallback(() => {
    const request = {};
    if (!_.isEmpty(RequestData) && !_.isEmpty(getCreateLetterDetailData)) {
      request.templateId =
        RequestData.selectedTemplate.templateId ||
        getCreateLetterDetailData?.templateId;
      request.templateVersion =
        RequestData.selectedTemplate.templateVersion ||
        getCreateLetterDetailData?.templateVersion;
      request.invoiceNumber = RequestData?.selectedTemplate?.invoiceNum;
      request.letterId = RequestData?.selectedTemplate?.letterId;
      // if (!RequestData?.selectedTemplate?.sentDt) {
      dispatch(
        fetchCreateLetterDetailByLetterIDData({
          preData: getCreateLetterDetail,
          request: { letterId: RequestData?.selectedTemplate?.letterId },
        })
      );
      // }
    }
    request.userId = logInUser;
    dispatch(
      dispatchGetToMailID({
        isUpdate: false,
        toMailId: getCreateLetterDetailData?.emailAddr,
      })
    );
    dispatch(getFromMailIDCreateTemplate({ userId: logInUser }));
    dispatch(getPrintPreview(request));
    dispatch(getPrintDraftPDFPreview(request));
  }, [RequestData, getCreateLetterDetailData]);

  // Refresh Page---
  React.useEffect(() => {
    if (
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.filter((x) => {
        return x.navTo === '/displayLetterDetail' && x.isRefresh;
      }).length > 0
    ) {
      const newObj = updateTabs.map((item) => {
        if (item.navTo === '/displayLetterDetail') {
          item.isRefresh = false;
        }
        return item;
      });
      setErrorStateChange({ detailScreenErrors: [] });
      if (!_.isEmpty(getCreateLetterDetailData)) {
        setLoading(false);
        callFewAPIWhenNotSameTemplate();
        localStorage.setItem('tabItemsData', JSON.stringify(newObj));
      }
    }
  }, [getCreateLetterDetailData]);

  // pdf url
  React.useEffect(() => {
    setLoading(false);
    if (pdfPreview && pdfPreview !== '') {
      const purl = convertPDFURLFromAPI(pdfPreview);
      setPdfURL(purl);
      if (extraState.printPdf) {
        if (getCreateLetterDetailHeader?.mediaCd === printMedia) {
          setStateChange({ printPdf: false });
          safeWindowOpen(purl);
        }
      }
    }
  }, [pdfPreview]);

  // draft pdf url
  React.useEffect(() => {
    setLoading(false);
    if (pdfDraftPreview && pdfDraftPreview !== '') {
      const purl = convertPDFURLFromAPI(pdfDraftPreview);
      setDraftPdfURL(purl);
    }
  }, [pdfDraftPreview]);

  // after Save letter
  React.useEffect(() => {
    if (extraState?.saveApiActive) {
      let msg = null;
      let viewMSg = false;
      if (!_.isEmpty(saveCreateLetterData)) {
        if (
          saveCreateLetterData.message === 'SUCESS' &&
          saveCreateLetterData.status === '001'
        ) {
          setLoading(false);
          const getData =
            extraState?.letterAction === 'SaveLetter'
              ? saveCreateLetterData?.displayLetterSaveOrUpdateVO
              : saveCreateLetterData.createLetterSaveOrUpdateVO;
          const data = getData.letterHeaderVO;
          if (!_.isEmpty(data)) {
            const request1 = {};
            request1.templateId = data.templateId;
            request1.templateVersion = data?.templateVersion;
            request1.invoiceNumber = data?.invoiceNum;
            // }
            request1.letterId = data.letterId;
            request1.userId = logInUser;
            dispatch(
              fetchCreateLetterDetail({
                request: request1,
                searchData: RequestData,
                headerDetail: data,
              })
            );
            setStateChange({
              letterAction: '',
              saveApiActive: false,
              sendEmail: false,
            });
            dispatch(getPrintPreview(request1));
            // dispatch(updateCreateLetterSaveApi([]));
            setErrorStateChange({ detailScreenErrors: [SAVE_NDC] });
          } else {
            setStateChange({
              letterAction: '',
              saveApiActive: false,
              sendEmail: false,
              printPdf: false,
            });
            setLoading(false);
            msg = getData?.actionFlag || FAIL_PROCESSING_REQUEST;
            viewMSg = true;
          }
        } else {
          setStateChange({
            letterAction: '',
            saveApiActive: false,
            sendEmail: false,
            printPdf: false,
          });
          setLoading(false);
          msg = FAIL_PROCESSING_REQUEST;
          viewMSg = true;
        }
        setModalView(viewMSg);
        setModalMsg(msg);
      }
    }
  }, [saveCreateLetterData, extraState?.saveApiActive]);

  // Role based access
  React.useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setIsEnablebyRole(
        checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
    }
  }, []);

  const onSaveLetter = (val) => {
    setLoading(true);
    if (val === 'SendLetterByEmail') {
      const request = {
        letterId: getCreateLetterDetailHeader?.letterId,
        contactTypeCd: getCreateLetterDetailData?.contactTypeCd,
        rebateProgramCd: getCreateLetterDetailHeader?.rebateProgramCd,
        mfgId: invoiceDetail?.mfgId,
        templateId: getCreateLetterDetailHeader?.templateId,
        templateVersion: getCreateLetterDetailHeader?.templateVersion,
        userId: logInUser,
        lobStagingVO: {
          dest: 'EMAIL',
          invNum: getCreateLetterDetailHeader?.invoiceNum,
          fileName: `Invoice_${getCreateLetterDetailHeader?.invoiceNum}`,
          fileContent: null,
          // toAddress: 'shravan.chaurasiya@conduent.com',
          // fromAddress: 'omkar.singh@conduent.com',
          toAddress: toMailId.toMailId,
          fromAddress: fromMailId.fromMailId,
          subject: getCreateLetterDetailData?.emailSubject,
          message: convertHtmlToEmailPlainText(
            getCreateLetterDetailData?.body || ''
          ),
          // message: 'Test',
        },
        corrCommentVO: {
          corrName: getCreateLetterDetailHeader?.corpName,
          corpName: getCreateLetterDetailHeader?.corpName,
          addrLine1: getCreateLetterDetailHeader?.addrLine1,
          addrLine2: getCreateLetterDetailHeader?.addrLine2,
          addrLine3: getCreateLetterDetailHeader?.addrLine3,
          city: getCreateLetterDetailHeader?.city,
          stateCd: getCreateLetterDetailHeader?.stateCd,
          zip: getCreateLetterDetailHeader?.zip,
          zip4: getCreateLetterDetailHeader?.zip4,
          emailAddr: getCreateLetterDetailHeader?.emailAddr,
          phoneNum: getCreateLetterDetailHeader?.phoneNum,
          phoneExtension: getCreateLetterDetailHeader?.phoneExtension,
          faxNum: getCreateLetterDetailHeader?.faxNum,
        },
      };
      if (request.lobStagingVO.toAddress && request.lobStagingVO.fromAddress) {
        setStateChange({
          letterAction: val,
          saveApiActive: false,
          sendEmail: true,
        });
        dispatch(sendMailWithCreateTemplate(request));
      } else {
        const valFor =
          !request.lobStagingVO.toAddress && !request.lobStagingVO.fromAddress
            ? 'To & From'
            : !request.lobStagingVO.toAddress
            ? 'To'
            : !request.lobStagingVO.fromAddress
            ? 'FROM'
            : '';
        setViewEmail(false);
        setLoading(false);
        const msg = EMAIL_ID_NOT_AVAILABLE(valFor);
        setModalView(true);
        setModalMsg(msg);
      }
    } else if (val === 'SaveLetter') {
      const req = {
        actionFlag: 'SaveDL',
        letterHeaderVO: {
          senderId: logInUser,
          letterId: getCreateLetterDetailHeader?.letterId,
          templateId: getCreateLetterDetailHeader?.templateId,
          templateVersion: getCreateLetterDetailHeader?.templateVersion,
          rebateProgramCd: getCreateLetterDetailHeader?.rebateProgramCd,
          templateTypeCd: getCreateLetterDetailHeader?.templateTypeCd,
          invoiceNum: getCreateLetterDetailHeader?.invoiceNum,
          freeFormText:
            getCreateLetterDetailHeader?.freeFormText ||
            getCreateLetterDetailData?.freeFormText,
          contactSeqNum: getCreateLetterDetailData?.contactSeqNum,
          recipientId:
            getCreateLetterDetailData?.recipientId ||
            getCreateLetterDetailHeader?.recipientId,
          sentDt: getCreateLetterDetailHeader?.sentDt,
        },
      };
      setStateChange({
        letterAction: val,
        saveApiActive: true,
        sendEmail: false,
        printPdf: false,
      });
      dispatch(saveDisplayLetterAPI(req));
    } else {
      const request = {
        letterId: null,
        userId: null,
      };
      if (!_.isEmpty(RequestData)) {
        request.letterId = RequestData?.selectedTemplate?.letterId;
      }
      request.userId = logInUser;
      setStateChange({
        letterAction: val,
        saveApiActive: true,
        sendEmail: false,
        printPdf:
          val === 'SendLetter' &&
          getCreateLetterDetailHeader?.mediaCd === printMedia,
      });
      dispatch(saveCreateTemplate(request));
    }
  };

  // after mail send done
  React.useEffect(() => {
    if (extraState?.sendEmail) {
      if (!_.isEmpty(sendMail)) {
        setViewEmail(false);
        if (sendMail.message === 'SUCESS' && sendMail.status === '001') {
          if (sendMail?.createLetterSendLetterVO?.sentDt) {
            dispatch(dispatchSendMailForLetter({}));
            onSaveLetter('SendLetterAfterEmail');
          } else {
            setLoading(false);
            setModalView(true);
            setModalMsg(FAIL_PROCESSING_REQUEST);
            setStateChange({
              letterAction: '',
              saveApiActive: false,
              sendEmail: false,
              printPdf: false,
            });
          }
        } else {
          setLoading(false);
          setModalView(true);
          setStateChange({
            letterAction: '',
            saveApiActive: false,
            sendEmail: false,
            printPdf: false,
          });
          setModalMsg(FAIL_PROCESSING_REQUEST);
        }
      }
    }
  }, [sendMail, extraState?.sendEmail]);

  const onSendLetterAction = () => {
    setErrorStateChange({ detailScreenErrors: [] });
    if (getCreateLetterDetailHeader?.mediaCd === printMedia) {
      onSaveLetter('SendLetter');
    } else if (
      !toMailId?.toMailId ||
      toMailId?.toMailId === '' ||
      !fromMailId?.fromMailId ||
      fromMailId?.fromMailId === ''
    ) {
      setEmailInputValue({
        to: toMailId?.toMailId || '',
        from: fromMailId?.fromMailId || '',
      });
      setViewEmailInput({
        to: !toMailId?.toMailId || toMailId?.toMailId === '',
        from: !fromMailId?.fromMailId || fromMailId?.fromMailId === '',
      });
      setViewEmail(true);
    } else {
      onSaveLetter('SendLetterByEmail');
    }
  };

  // after update email ids
  React.useEffect(() => {
    if (toMailId?.isUpdate || fromMailId?.isUpdate) {
      if (
        toMailId?.toMailId &&
        toMailId?.toMailId !== '' &&
        fromMailId?.fromMailId &&
        fromMailId?.fromMailId !== ''
      ) {
        onSaveLetter('SendLetterByEmail');
      } else {
        setModalView(true);
        setModalMsg(FAIL_PROCESSING_REQUEST);
      }
      dispatch(
        dispatchGetToMailID({
          isUpdate: false,
          toMailId: toMailId.toMailId,
        })
      );
      dispatch(
        dispatchGetFromMailID({
          isUpdate: false,
          fromMailId: fromMailId.fromMailId,
        })
      );
    }
  }, [toMailId, fromMailId]);

  const mailAction = (flType, val) => {
    setEmailInputValue({
      ...emailInputValue,
      [flType]: val,
    });
  };

  // update email after click ok in email modal and save
  const onOkUpdateToMailId = () => {
    if (viewEmailInput.to && !toEmailIdValid) {
      if (emailInputValue.to && emailInputValue.to !== '') {
        const request = {};
        if (
          getCreateLetterDetailData &&
          !_.isEmpty(getCreateLetterDetailData)
        ) {
          request.contactSeqNum = getCreateLetterDetailData.contactSeqNum;
          request.mailId = emailInputValue.to;
          request.userId = logInUser;
          dispatch(updateToMailIDCreateTemplate(request));
        }
      }
    }
    if (viewEmailInput.from && !fromEmailIdValid) {
      if (emailInputValue.from && emailInputValue.from !== '') {
        dispatch(
          updateFromMailIDCreateTemplate({
            mailId: emailInputValue.from,
            userId: logInUser,
          })
        );
      }
    }
  };

  // Redirect invoice detail page after calling invoice api
  React.useEffect(() => {
    setLoading(false);
    if (
      redirect &&
      invoiceDetailsByInvoiceNum &&
      !_.isEmpty(invoiceDetailsByInvoiceNum)
    ) {
      setRedirect(false);
      const updateTabs1 = _.cloneDeep(updateTabs);
      updateTabs1.push({
        navTo: '/display-invoice',
        value: 'Display Invoice',
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs1));
      history.push({
        pathname: '/display-invoice',
        invoiceDetailsByInvoiceNum: invoiceDetailsByInvoiceNum.data,
      });
    }
  }, [invoiceDetailsByInvoiceNum]);

  // go to particular invoice action button handler function
  const goToInvoice = async () => {
    setErrorStateChange({ detailScreenErrors: [] });
    if (!_.isEmpty(RequestData) && !_.isEmpty(invoiceDetail)) {
      setRedirect(true);
      setLoading(true);
      dispatch(
        getInvoiceDetailsByInvNum({
          invoiceNum: RequestData?.selectedTemplate?.invoiceNum,
        })
      );
    }
  };

  // go to particular Contract action button handler function
  const goToContract = async () => {
    setErrorStateChange({ detailScreenErrors: [] });
    if (invoiceDetail && !_.isEmpty(invoiceDetail)) {
      dispatch(dispatchCellClick(true));
      dispatch(selectedType('C'));
      searchContractState.contractType = 'onSelect';
      searchContractState.selectedContractType = 'contractId';
      searchContractState.selectedRowData = invoiceDetail?.contractSeqNum;
      searchContractState.selectedContractId = invoiceDetail?.contractSeqNum;
      searchContractState.rebateProgramCode = invoiceDetail?.rebateProgramCd;
      const updateTabs1 = _.cloneDeep(updateTabs);
      updateTabs1.push({
        navTo: '/createContract',
        value: 'Maintain Contract',
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs1));
      history.push({
        pathname: '/createContract',
      });
    }
  };

  // go to particular manufacturer action button handler function
  const goToManufacturer = async () => {
    setErrorStateChange({ detailScreenErrors: [] });
    if (invoiceDetail && !_.isEmpty(invoiceDetail)) {
      dispatch(setSelectManufacturerData({}));
      dispatch(fetchAllManufacturerDetail(null));
      dispatch(getContactDetails(null));
      dispatch(maintainLabelerListData({}));
      dispatch(setMaintainManufacturerTab({}));
      const tempObj = {
        mfgId: invoiceDetail?.mfgId,
        mfgName: invoiceDetail?.mfgName,
        mfgTypeCd: 'C',
      };
      tempObj.updateManufacturer = true;
      const result = await dispatch(setSelectManufacturerData(tempObj));
      if (result && Object.keys(result).length > 0) {
        redirectURLLink(
          '/manufacturer-detail',
          'Maintain Manufacturer',
          history,
          dispatch
        );
      }
    }
  };

  // go to particular Rebate Program action button handler function
  React.useEffect(() => {
    if (redirect && pgmView && pgmView.status === '001') {
      setRedirect(false);
      setLoading(false);
      const updateTabs1 = _.cloneDeep(updateTabs);
      const MAINTAIN_ROUTE = '/maintainRebate';
      if (!updateTabs1.some((ob) => ob.navTo === MAINTAIN_ROUTE)) {
        updateTabs1.push({
          navTo: MAINTAIN_ROUTE,
          value: 'Maintain Rebate Program',
        });
        localStorage.setItem('tabItemsData', JSON.stringify(updateTabs1));
      }
      localStorage.setItem('viewpgmdetails', 'true');
      history.push({ pathname: MAINTAIN_ROUTE });
    }
  }, [pgmView]);

  const goToRebateProgram = async () => {
    setErrorStateChange({ detailScreenErrors: [] });
    if (invoiceDetail && !_.isEmpty(invoiceDetail)) {
      const request = {
        planType: invoiceDetail?.planTypeCode,
        rebateProg: invoiceDetail?.rebateProgramCd,
      };
      setRedirect(true);
      setLoading(true);
      dispatch(getRebatePgmDetail(request));
    }
  };

  // full screen action
  const handleFullScreenView = (view) => {
    const dataSet = {
      ...extraState.fullScreenView,
      templateDetail: view,
    };
    setStateChange({ fullScreenView: dataSet });
  };

  const onClickPrint = (flType) => {
    setErrorStateChange({ detailScreenErrors: [] });
    let urls = '';
    if (flType === printMedia && pdfUrl && pdfUrl !== '') {
      urls = pdfUrl;
    }
    if (flType === printDraft && draftPdfUrl && draftPdfUrl !== '') {
      urls = draftPdfUrl;
    }
    if (urls && urls !== '') {
      safeWindowOpen(urls);
    }
  };

  return (
    <div className=' tabs-container' data-testid='DisplayLetterDetail'>
      <Spinner load={loading} />
      <CustomSeparator parent1='Display' parent2='Display Letter Details' />
      <DisplaySuccessMessages
        successMessages={errorMessagesFromRedux?.detailScreenErrors || []}
      />
      <div className='tab-container' bodyground='white'>
        {!fullScreenView && (
          <div className='mui-custom-form no-margin custom-check'>
            <div className='mt-2'>
              <fieldset
                data-testid='radio-box-component'
                className='custom-fieldset'
              >
                <div className='row'>
                  <div className='col-12 col-sm-3 mb-2'>
                    <SelectBoxWithoutBoxComponent
                      data-testid='letter-id-select-box'
                      className='mt-2'
                      labelName='Letter ID'
                      disabled
                      select={false}
                      defaultValue={getCreateLetterDetailHeader?.letterId}
                    />
                  </div>
                  <div className='col-12 col-sm-3 mb-2'>
                    <SelectBoxWithoutBoxComponent
                      data-testid='name-input-box'
                      className='mt-2'
                      labelName='Name'
                      required={false}
                      disabled
                      select={false}
                      defaultValue={
                        RequestData?.selectedTemplate
                          ? RequestData?.selectedTemplate?.templateName
                          : ''
                      }
                    />
                  </div>
                  <div className='col-12 col-sm-3 mb-2'>
                    <SelectBoxWithoutBoxComponent
                      data-testid='mfg-id-input-box'
                      className='mt-2'
                      labelName='Mfg ID'
                      required={false}
                      disabled
                      select={false}
                      defaultValue={
                        getCreateLetterDetailData
                          ? getCreateLetterDetailData?.mfgId
                          : ''
                      }
                    />
                  </div>
                  <div className='col-12 col-sm-3 mb-2'>
                    <SelectBoxWithoutBoxComponent
                      data-testid='Sent-input-box'
                      labelName='Sent'
                      required={false}
                      disabled
                      select={false}
                      defaultValue={getCreateLetterDetailHeader?.sentDt || ''}
                      className={
                        getCreateLetterDetailHeader?.sentDt
                          ? 'mt-2'
                          : 'mt-2 frr-letter-used-indicator'
                      }
                    />
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
        )}
        {/* {!fullScreenView && (
          <div className='row mt-4 mb-3'>
            <div className='col-12'>
              <div className='btn-wrapper float-right'>
                <Button
                  className='btn btn-success btn-save'
                  data-testid='open_Save'
                  // disabled
                  // onClick={() => onSaveLetter('SaveLetter')}
                >
                  <SVGComponent iconName='Icon-awesome-save' />
                  Save
                </Button>
              </div>
            </div>
          </div>
        )} */}

        <div className='custom-check'>
          <div className='float-left'>
            <CLTabs
              data-testid='letter-template-tabs-comp'
              tabValue={tabs}
              handleChangeTabValue={(newValue) => {
                setStateChange({ tabs: newValue });
              }}
            />
          </div>

          <div className='float-right mt-2'>
            <div className='panel-header'>
              <div className='float-right th-icon-group mt-3'>
                <div className='panel-header'>
                  <OverlayTrigger
                    placement='bottom'
                    overlay={<Tooltip id='action-tooltip'>Action</Tooltip>}
                  >
                    <div className='th-icon ic-actions'>
                      <Dropdown className='icon-dropdown-container'>
                        <Dropdown.Toggle
                          className='icon-dropdown'
                          aria-label='Write Off'
                        >
                          {/* <SVGComponent iconName="Icon-export1" /> */}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            role='button'
                            data-testid='create-letter-print-tab'
                            onClick={() => {
                              onClickPrint(
                                getCreateLetterDetailHeader?.sentDt
                                  ? printMedia
                                  : printDraft
                              );
                            }}
                          >
                            {getCreateLetterDetailHeader?.sentDt
                              ? 'Print'
                              : 'Print Draft'}
                          </Dropdown.Item>
                          {!getCreateLetterDetailHeader?.sentDt &&
                            getCreateLetterDetailHeader?.templateTypeCd !==
                              'COVER' && (
                              <Dropdown.Item
                                role='button'
                                data-testid='create-letter-send-letter-tab'
                                onClick={onSendLetterAction}
                                disabled={!isEnablebyRole}
                              >
                                Send Letter
                              </Dropdown.Item>
                            )}
                          {tabs !== 'Preview' && (
                            <Dropdown.Item
                              role='button'
                              data-testid='create-letter-preview-tab'
                              onClick={() => {
                                setErrorStateChange({ detailScreenErrors: [] });
                                setStateChange({ tabs: 'Preview' });
                              }}
                            >
                              Preview
                            </Dropdown.Item>
                          )}
                          {tabs !== 'HeaderFooter' && (
                            <Dropdown.Item
                              role='button'
                              data-testid='create-letter-header-footer-tab'
                              onClick={(e) => {
                                setErrorStateChange({ detailScreenErrors: [] });
                                setStateChange({ tabs: 'HeaderFooter' });
                              }}
                              value='header/footer'
                            >
                              Show Header/Footer
                            </Dropdown.Item>
                          )}
                          {tabs !== 'Body' && (
                            <Dropdown.Item
                              role='button'
                              data-testid='create-letter-body-tab'
                              onClick={() => {
                                setErrorStateChange({ detailScreenErrors: [] });
                                setStateChange({ tabs: 'Body' });
                              }}
                            >
                              Show Main
                            </Dropdown.Item>
                          )}
                          <Dropdown.Item
                            role='button'
                            data-testid='create-letter-goto-invoice-tab'
                            onClick={goToInvoice}
                          >
                            Go To Invoice
                          </Dropdown.Item>
                          <Dropdown.Item
                            role='button'
                            data-testid='create-letter-goto-contact-tab'
                            onClick={goToContract}
                          >
                            Go To Contract
                          </Dropdown.Item>
                          <Dropdown.Item
                            role='button'
                            data-testid='create-letter-goto-manufacturer-tab'
                            onClick={goToManufacturer}
                          >
                            Go To Manufacturer
                          </Dropdown.Item>
                          <Dropdown.Item
                            role='button'
                            data-testid='create-letter-goto-rebate-program-tab'
                            onClick={goToRebateProgram}
                          >
                            Go To Rebate Program
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </OverlayTrigger>

                  <OverlayTrigger
                    placement='bottom'
                    overlay={
                      <Tooltip id='fullScreen-tooltip'>
                        {fullScreenView ? 'Minimize Screen' : 'Full Screen'}
                      </Tooltip>
                    }
                  >
                    <div
                      className={
                        fullScreenView
                          ? 'th-icon ic-fulScreen-exit'
                          : 'th-icon ic-fulScreen'
                      }
                      role='button'
                      data-testid='setFullScreenView'
                      onClick={() => handleFullScreenView(!fullScreenView)}
                    >
                      <span className='ic-title'>
                        {fullScreenView ? 'Minimize Screen' : 'Full Screen'}
                      </span>
                    </div>
                  </OverlayTrigger>
                </div>
              </div>
            </div>
          </div>
          <div className='clearfix devider-line' />

          <div className='tabs-body'>
            {tabs === 'Body' && (
              <div className='frr-displayDisabledContent disabled'>
                <SafeHtmlContent html={getCreateLetterDetailData?.body} />
              </div>
            )}
            {tabs === 'HeaderFooter' && (
              <div>
                <div className='mt-2 frr-displayDisabledContent disabled'>
                  <SafeHtmlContent html={getCreateLetterDetailData?.header} />
                </div>
                <div className='mt-2 frr-displayDisabledContent disabled'>
                  <SafeHtmlContent html={getCreateLetterDetailData?.footer} />
                </div>
              </div>
            )}
            {tabs === 'Preview' && <Preview pdfUrlLink={pdfUrl} />}
          </div>
        </div>
      </div>

      {modalView && modalMsg && (
        <CommonModal
          data-testid='template-detail-errorModal-comp'
          className='dialog-420'
          open={modalView}
          viewHeader
          viewAction
          onOk={() => {
            // if (modalMsg === SAVE_NDC) {
            //   callAfterSaveDone();
            // } else {
            setModalMsg(null);
            setModalView(false);
            // }
          }}
          okTitle='Ok'
          onClose={() => {
            setModalMsg(null);
            setModalView(false);
          }}
          closeTitle={false}
          modalTitle='Warning'
          childrenComponent={<div className='p-3'>{modalMsg}</div>}
        />
      )}

      <div>
        <CommonModal
          open={viewEmail}
          viewAction
          viewHeader
          data-testid='template-detail-errorModal-comp1'
          className='dialog-420'
          okTitle='Ok'
          onOk={onOkUpdateToMailId}
          onClose={() => {
            setEmailInputValue({ to: '', from: '' });
            setViewEmailInput({ to: false, from: false });
            setToEmailValid(false);
            setFromEmailValid(false);
            setViewEmail(false);
          }}
          closeTitle='Cancel'
          modalTitle='Request Email Address'
          childrenComponent={
            <div className='mb-2'>
              <p className='float-right'>
                <OverlayTrigger
                  placement='bottom'
                  overlay={<Tooltip id='print-tooltip'>Print</Tooltip>}
                >
                  <div className='top-bell-icon th-icon'>
                    {getCreateLetterDetailData?.mediaCd === eitherMedia ? (
                      <div
                        onClick={() =>
                          onClickPrint(
                            getCreateLetterDetailHeader?.sentDt
                              ? printMedia
                              : printDraft
                          )
                        }
                      >
                        <SVGComponent iconName='Icon-printer' />
                      </div>
                    ) : (
                      <SVGComponent iconName='Icon-printer-disabled' />
                    )}
                  </div>
                </OverlayTrigger>
              </p>
              <p>{ENTER_VALID_EMAIL_OR_CANCEL}</p>
              {viewEmailInput.to && (
                <SelectBoxWithoutBoxComponent
                  data-testid='email-id-select-box'
                  className='mt-2'
                  labelName={invoiceDetail.contactName}
                  placeholder='Email ID'
                  required
                  select={false}
                  inputProps={{ maxLength: 50 }}
                  defaultValue={emailInputValue.to}
                  filterAction={(e) => mailAction('to', e)}
                  onBlurAction={(e) => setToEmailValid(!emailValidation(e))}
                  isError={
                    toEmailIdValid
                      ? emailInputValue.to && emailInputValue.to !== ''
                        ? EMAIL_INVALID
                        : EMAIL_REQUIRED
                      : null
                  }
                />
              )}
              {viewEmailInput.from && (
                <SelectBoxWithoutBoxComponent
                  data-testid='email-id-select-box'
                  className='mt-2'
                  labelName={logInUser}
                  placeholder='Email ID'
                  required
                  select={false}
                  inputProps={{ maxLength: 50 }}
                  defaultValue={emailInputValue.from}
                  filterAction={(e) => mailAction('from', e)}
                  onBlurAction={(e) => setFromEmailValid(!emailValidation(e))}
                  isError={
                    fromEmailIdValid
                      ? emailInputValue.from && emailInputValue.from !== ''
                        ? EMAIL_INVALID
                        : EMAIL_REQUIRED
                      : null
                  }
                />
              )}
            </div>
          }
        />
      </div>
    </div>
  );
}

export default CreateLetterDetail;
